module.exports = __webpack_public_path__ + "img/B7.2913d1a0.png";